import React, {useState} from 'react';
import {Card, ListGroup} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCopy} from '@fortawesome/free-solid-svg-icons';
import {copyManualIdToClipboard, handleManualClick} from '../../utils/manualFinderUtils';
import {IImageManualModel} from '../../types/manualFinder';
import {useTranslation} from 'react-i18next';
import {useExtractedImagesState} from "../../hooks";

interface ManualItemProps {
    manual: IImageManualModel;
}

const ManualDrawerItem: React.FC<ManualItemProps> = ({manual}) => {
    const {t} = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const {selectedImages} = useExtractedImagesState();
    return (
        <ListGroup.Item className="manual-item">
            <Card className="manual-card">
                <Card.Header className="d-flex flex-column align-items-center">
                    <Card.Title>
                        <div className="d-flex gap-2">
                            <span>ID: {manual.manualId}</span>
                            <FontAwesomeIcon
                                icon={faCopy}
                                className="copy-icon"
                                role="button"
                                onClick={() =>
                                    copyManualIdToClipboard(
                                        manual.manualId,
                                        t("SpecialTool.CopyIdClipboardMessage").replace("{}", manual.manualId)
                                    )
                                }
                            />
                        </div>
                    </Card.Title>
                    <Card.Subtitle className="text-muted">
                        {`(${manual.imageFileNameCount}/${selectedImages.length} image(s) found)`}
                    </Card.Subtitle>
                </Card.Header>
                <Card.Body className="d-flex flex-column gap-2">
                    <span className="fw-bold">{manual.itemMpText}</span>
                    <span className="fw-bold hyper-link"
                          onClick={() => handleManualClick(manual.manualId, setIsLoading, t)}>
                        {manual.manualName}
                    </span>
                </Card.Body>
            </Card>
        </ListGroup.Item>
    );
};

export default ManualDrawerItem;
